<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Aba
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Nome da Aba*"
                  counter="40"
                  outlined
                  dense
                  maxlength="40"
                  :rules="[(v) => $required(v)]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nomeDeExibicao"
                  label="Nome de Exibição*"
                  counter="40"
                  maxlength="40"
                  outlined
                  dense
                  :rules="[(v) => $required(v)]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-select
                  v-model="content.permissoes"
                  :items="form.lists.listPermissoes"
                  :item-text="'nomeDeExibicao'"
                  :item-value="'id'"
                  :rules="[(p) => p.some(v => $required(v)) || 'Campo obrigatório']"
                  label="Permissões*"
                  multiple
                  outlined
                  dense
                  return-object
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Salvar' : 'Salvar'"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Aba } from '~/commons/classes/aba';
import AbaService from '~/services/manter-aba.service';
import PermissaoService from '~/services/permissao.service';
export default {
  props: new DialogProps(Aba),
  mixins: [AbaService, PermissaoService],
  data: () => ({
    form: {
      lists: {
        listPermissoes: [],
      },
    }
  }),
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar a operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const payloadCad = new Aba(this.content).format();   
          const payloadEdit = {
            ...this.content,
            permissoes: this.content.permissoes.map((p) => 
              typeof p === 'object' ? p.id : p
            ),
          };       
          return this.edit
            ? this.$editarAba(payloadEdit, this.content.id)
            : this.$cadastrarAba(payloadCad);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
  },
  mounted() {
    this.$buscarTodasPermissoes().then(({ data }) => {
      this.form.lists.listPermissoes = data.permissoes;
    });
  }
};
</script>
